var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHurtsLittleMore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.931 39.8621C14.6073 39.8621 9.60215 37.7889 5.83765 34.0244C2.07316 30.2599 0 25.2548 0 19.931C0 14.6073 2.07316 9.60215 5.83765 5.83773C9.60215 2.07331 14.6073 0 19.931 0C25.2548 0 30.2599 2.07324 34.0244 5.83773C37.7889 9.60223 39.8621 14.6073 39.8621 19.9311C39.8621 25.2549 37.7889 30.26 34.0244 34.0245C30.2599 37.789 25.2548 39.8621 19.931 39.8621ZM19.931 2.33578C15.2312 2.33578 10.8126 4.16602 7.48928 7.48928C4.16594 10.8125 2.33578 15.2312 2.33578 19.931C2.33578 24.6309 4.16602 29.0494 7.48928 32.3727C10.8126 35.6961 15.2311 37.5262 19.931 37.5262C24.6308 37.5262 29.0494 35.696 32.3726 32.3727C35.696 29.0494 37.5261 24.6309 37.5261 19.931C37.5261 15.2312 35.6959 10.8126 32.3726 7.48928C29.0494 4.16594 24.6309 2.33578 19.931 2.33578Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8812 26.822H27.9808V29.1578H11.8812V26.822Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34024 16.0125H15.7277V18.3482H9.34024V16.0125Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1344 16.0125H30.5218V18.3482H24.1344V16.0125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurtsLittleMore);
export default __webpack_public_path__ + "static/media/hurtsLittleMore.b4aa07ffad7f0799556cd7b72475b78d.svg";
export { ForwardRef as ReactComponent };